import React from 'react';
import Form from '../../components/common/Form';
// import Joi from 'joi-browser';
import toastr from "toastr";
import {Link} from "react-router-dom";

class InviteAdminsFeedModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            teamMembers: ['member_1', 'member_2', 'member_3'],
            team_name: props.team_name || "",
            team_id: props.team_id || "",

            data: {

                member_1: '',
                member_2: '',
                member_3: ''
            },
            spinnerActive: false,

            errors: {},
        };
    }

    // schema = {
    //     member_1: Joi.string().email().allow('').label('The field'),
    //     member_2: Joi.string().email().allow('').label('The field'),
    //     member_3: Joi.string().email().allow('').label('The field')
    // };

    getEmailsFromInputs = () => {
        const collection = document.getElementsByTagName("input");
        const inputs = [...collection];

        const emails = inputs.map(input => {
            if (input.value) {
                return input.value;
            } else {
                return null
            }
        });
        return emails.filter(function (el) {
            return el != null;
        });
    };


    showInviteLink = () => {
        let show = this.state.showLink;
        show = show !== true;
        this.setState({
            showLink: show
        })
    };


    // addNewMember = () => {
    //     let teamMembers = [...this.state.teamMembers];
    //     let membersCount = teamMembers.length + 1;
    //     let newMember = 'member_' + membersCount;
    //
    //     teamMembers.push(newMember);
    //
    //     let schema = {...this.schema};
    //     let data = {...this.state.data};
    //     data[newMember] = '';
    //     schema[newMember] = Joi.string().email().allow('').label('The field');
    //     this.schema = schema;
    //     this.setState({
    //             teamMembers: this.state.teamMembers.concat(newMember),
    //             data: data
    //         }
    //     );
    // };

    doSubmit = async (e) => {
        const data = this.state.data;
        const team_id = this.state.team_id;
        const emails = this.getEmailsFromInputs();
        // console.log('data: ', data);
        // console.log('teamId: ', team_id);
        // console.log('emails: ', emails);

        this.setState({spinnerActive: true});
        this.props.acceptModal(e, data, team_id, emails);
    };

    render() {
        let {visible_modal, onClickAway} = this.props;

        return (
            <div id="newAdminModal" className="text-left modal in"
                 style={visible_modal ? {display: "block"} : {display: "none"}}>
                {/*<div className="modal-content">*/}
                {/*    <div className="onboarding-panel">*/}
                {/*        <h1 className='onboarding-title distribution-title m-lg-b'><span>Ma cao Invite Project Admins</span>*/}
                {/*        </h1>*/}
                {/*        <p className='m-m-b'>Project admins will be granted admin access to <br/>*/}

                {/*             <span className='text-light-blue'>&lt;{this.state.team_name}&gt;</span> only.*/}
                {/*        </p>*/}
                {/*        <form onSubmit={this.handleFormSubmit}>*/}
                {/*            <div id='team-members'>*/}

                {/*                {this.state.teamMembers.map(member => {*/}


                {/*                        return <div key={member}>*/}
                {/*                            {this.renderInput(member, 'text', 'name@example.com')}*/}

                {/*                        </div>*/}
                {/*                    }*/}
                {/*                )*/}
                {/*                }*/}


                {/*            </div>*/}
                {/*            <p*/}
                {/*                className=' add-new-member  m-s-t m-m-b text-right'>*/}
                {/*                <p className='text-light-blue pointer' onClick={this.addNewMember}>*/}
                {/*                    <span className='fas fa-plus-circle'></span>*/}
                {/*                    Add another*/}
                {/*                </p></p>*/}


                {/*            {!this.state.spinnerActive ?*/}
                {/*                <button*/}
                {/*                    disabled={this.validate()}*/}
                {/*                    onClick={this.doSubmit}*/}
                {/*                    name="invite_to_feed"*/}
                {/*                    id="invite_to_feed"*/}
                {/*                    type="button"*/}
                {/*                    className='btn-action btn-sm m-sm-b center'>Add Teammates</button> :*/}

                {/*                this.renderButtonSpinner("Add Teammates")*/}
                {/*            }*/}

                {/*        </form>*/}

                {/*        /!* {this.state.showLink ?*/}
                {/*            <div>*/}
                {/*                <Link onClick={this.showInviteLink} to="#"><p*/}
                {/*                    className='text-light-blue m-m-t m-sm-b'><span*/}
                {/*                    className='fas fa-link'></span> Hide invite link</p></Link>*/}
                {/*                <div className='input-button'>*/}
                {/*                    <input id='input-button' value='http://www.emitto.io/%20%ion%20%…' type="text"/>*/}
                {/*                    <button onClick={this.copyLink} className='subscribers-search-btn'>Copy Link*/}
                {/*                    </button>*/}
                {/*                </div>*/}
                {/*            </div> :*/}
                {/*            <Link onClick={this.showInviteLink} to="#"><p*/}
                {/*                className='text-light-blue m-m-t m-sm-b'><span*/}
                {/*                className='fas fa-link'></span> Get an invite link to*/}
                {/*                share</p></Link>*/}
                {/*        } *!/*/}
                {/*        <div className='panel-message text-center'>*/}
                {/*            <p><Link onClick={onClickAway} to='#'>Cancel</Link></p>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*</div>*/}

            </div>
        )
    }
}

export default InviteAdminsFeedModal;